<template>
    <div>
        <div class="row mb-8">
            <div class="col-6 d-flex justify-content-start">
                <v-card-title>{{ $t('clients.clientDetails') }} </v-card-title>
            </div>
        </div>
    </div>
    <v-card flat>
        <v-tabs v-model="tab" background-color="transparent" color="basil" grow fixed-tabs>
            <v-tab class="slider" value="option-1" :style="NotActive" centered v-model="general">
                {{ $t('suppliers.general') }}</v-tab>
            <v-tab class="slider" value="option-2" :style="NotActive" centered v-model="general">
                {{ $t('suppliers.documents') }}</v-tab>
            <v-tab class="slider" value="option-3" :style="NotActive" centered v-model="general">
                    {{ $t('suppliers.validation') }}</v-tab>
        </v-tabs>

        <v-divider class="ma-0"></v-divider>
        <v-window v-model="tab" :key="tab">
            <v-window-item value="option-1">
                <client-general-information-tab ref="generalInformationListRef" />
            </v-window-item>
            <v-window-item value="option-2">
                <client-documents-tab ref="DocumentsListRef" />
            </v-window-item>
            <v-window-item value="option-3">
                <client-validation-tab ref="ValidationListRef" />
            </v-window-item>
        </v-window>
    </v-card>
</template>
<script>
//import { status } from "@/enums/Status";
import ClientDocumentsTab from "./ClientDocumentsTab.vue";
import ClientGeneralInformationTab from "./ClientGeneralInformationTab.vue";
import ClientValidationTab from "./ClientValidationTab.vue";

export default {
    mounted() {
        document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.client');
    },
    name: "ClientsDetails",
    components: {
        ClientGeneralInformationTab, ClientDocumentsTab,ClientValidationTab
    },
    data: () => ({
        tab: "option-1",
        general: true,
        step: 1,
        NotActive: {
            color: "#667280",
            fontSize: "14px",
            font: "inter",
        },
        canEditGeneralInformation: false,
        isDisabled: {
            type: Boolean,
            default: false
        },
    }),
    created() {
    },
    methods: {
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
        /*getStatusSupplierById: function () {
            this.StatusLoader = true
            getSupplierById(this.idSupplier)
                .then(({ data }) => {
                    this.Status = data.validationStatus
                }).finally(() => {
                    this.StatusLoader = false;
                });
        },*/
    },
    computed: {
        /*statusText() {
            switch (this.Status) {
                case 1: return localStorage.getItem(status.created + this.$i18n.locale);
                case 2: return localStorage.getItem(status.validatedClient1 + this.$i18n.locale);
                case 3: return localStorage.getItem(status.validatedBySupplier + this.$i18n.locale);
                case 4: return localStorage.getItem(status.validatedByClient2 + this.$i18n.locale);
                default: return localStorage.getItem(status.created + this.$i18n.locale);
            }
        }*/
    }
}
</script>
<style scoped>
.v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}

.text-basil {
    color: #114ef7 !important;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    font-family: inter;
}

.slider {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    flex: content;
    border-bottom: "2px solid black";
}

.disabled {
    opacity: 0.5;
    pointer-events: none;
}
</style>